export default {
  render: {
    hint: {
      blankCellContent: '--',
      cancel: 'Cancel',
      confirm: 'OK',
      datePlaceholder: 'Select date',
      defaultActiveText: 'True',

      defaultInactiveText: 'False',
      deleteSubFormRow: 'delete this row',
      downloadFile: 'Download',
      endDatePlaceholder: 'End date',
      endTimePlaceholder: 'End time',
      fieldRequired: 'Input value should be not null.',
      fileSizeExceed: 'File size out of limit: ',
      insertSubFormRow: 'insert new row',

      invalidNumber: 'Invalid number format',
      nonSubFormType: "The type of widget don't match sub-form",
      prompt: 'Prompt',
      refNotFound: 'Ref not found: ',
      removeFile: 'Remove',
      selectFile: ' File...',
      selectPlaceholder: 'Pick some item',
      startDatePlaceholder: 'Start date',
      startTimePlaceholder: 'Start time',
      subFormAction: 'Action',
      subFormAddAction: 'Add',

      subFormAddActionHint: 'add new row',
      subFormRowNo: '#',
      timePlaceholder: 'Select time',
      unsupportedFileType: 'Unsupported format: ',
      uploadError: 'Upload error: ',
      uploadExceed: 'The maximum number(${uploadLimit}) of file uploads has been exceeded.',
      validationFailed: 'Form validation failed',
    },
  },
};
